import { Permisos_recep } from './../../../models/permisos_recep.model';
import { Component, ViewChild, TemplateRef } from "@angular/core";
import * as moment from 'moment'
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { FormService } from 'src/app/services/form.service';
import { MatDialog } from '@angular/material/dialog';
declare var jQuery: any;
declare var $: any;
@Component({
    selector: "page-permisos_recep",
    templateUrl: "./permisos_recep.component.html",
    styleUrls: ["./permisos_recep.component.css"],
    providers: [FormService]
})

export class Permisos_recepComponent {
    @ViewChild('openModal', { static: true }) openModal: TemplateRef<any>;
    @ViewChild('openModalNODATA', { static: true }) openModalNODATA: TemplateRef<any>;

    public rows = [];
    public actualRow;
    public permisos_recep: Permisos_recep;
    public form;
    public temp_perm;
    public matcher = new FormService();
    public maxDate;
    public fecha1;
    public fecha2;
    public selected;

    constructor(private fb: FormBuilder, private dialog: MatDialog) {
        this.maxDate = moment().toDate()

        this.form = new FormGroup({
            tipo_permiso: new FormControl(''),
            permiso: new FormControl(''),
            numero: new FormControl('', [Validators.min(0),Validators.pattern(/[0-9]*/)]),
            fecha: new FormControl({ value: '', disabled: true }),
            superficie: new FormControl(''),
            recepcion: new FormControl(''),
            fecha_recep: new FormControl({ value: '', disabled: true }),

        })


        if (!JSON.parse(localStorage.getItem("permisos_recep"))) {
            localStorage.setItem("permisos_recep", JSON.stringify(this.rows));
        } else {
            this.rows = JSON.parse(localStorage.getItem("permisos_recep"));

        }
        this.permisos_recep = { tipo_permiso: '', permiso: '', numero: 0, fecha: null, superficie: 0, recepcion: '', fecha_recep: null };
        this.temp_perm = { tipo_permiso: '', permiso: '', numero: 0, fecha: null, superficie: 0, recepcion: '', fecha_recep: null };

    }

    add_permisos_recep() {

        console.log("add_permisos_recep() permisos_recep.components.ts");

        if (this.form.get('fecha').value) {
            this.fecha1 = moment(this.form.get('fecha').value).format('DD/MM/YYYY')
        } else {
            this.fecha1 = '';
        }
        if (this.form.get('fecha_recep').value) {
            this.fecha2 = moment(this.form.get('fecha_recep').value).format('DD/MM/YYYY')
        } else {
            this.fecha2 = '';
        }

        this.actualRow = localStorage.getItem("permisos_recep");
        this.rows = JSON.parse(this.actualRow);

        if (!this.form.value.permiso && !this.form.value.numero && !this.form.value.fecha1 && !this.form.value.superficie
            && !this.form.value.recepcion && !this.fecha2) {

            console.log("no se ingresaron datos add_permisos_recep this.form.value", this.form.value)
            this.dialog.open(this.openModalNODATA);
        } else {
            this.rows = this.rows.concat({
                tipo_permiso: this.form.value.tipo_permiso,
                permiso: this.form.value.permiso,
                numero: this.form.value.numero,
                fecha: this.fecha1,
                superficie: this.form.value.superficie,
                recepcion: this.form.value.recepcion,
                fecha_recep: this.fecha2

            })
            localStorage.setItem("permisos_recep", JSON.stringify(this.rows));
            this.form.reset();
        }

    }
    delete_permisos_recep(id) {
        for (let x = 0; x < this.rows.length; x++) {
            if (id == x) {
                this.rows.splice(x, 1);
                localStorage.setItem("permisos_recep", JSON.stringify(this.rows));
            }
        }
        this.actualRow = localStorage.getItem("permisos_recep");
        this.rows = JSON.parse(this.actualRow);
    }

    onChangeSelect(event) {
        let value = event.target.value;
        console.log(value);
    }
    get_permisos_recep(id) {
        console.log(id)
        for (let x = 0; x < this.rows.length; x++) {

            if (id == x) {
                this.temp_perm.id = id;
                this.temp_perm.tipo_permiso = this.rows[x].tipo_permiso;
                this.temp_perm.permiso = this.rows[x].permiso;
                this.temp_perm.numero = this.rows[x].numero;
                this.temp_perm.fecha = this.rows[x].fecha;
                this.temp_perm.superficie = this.rows[x].superficie;
                this.temp_perm.recepcion = this.rows[x].recepcion;
                this.temp_perm.fecha_recep = this.rows[x].fecha_recep;

                console.log(this.temp_perm);
                this.dialog.open(this.openModal);

            }
        }
    }

    cleanData() {
        this.temp_perm = { tipo_permiso: '', permiso: '', numero: 0, fecha: null, superficie: 0, recepcion: '', fecha_recep: null };

    }

    savepermisos_recep() {
        var id = this.temp_perm.id;
        console.log(this.temp_perm)
        for (let x = 0; x < this.rows.length; x++) {
            if (id == x) {
                this.rows.splice(x, 1);
                localStorage.setItem("permisos_recep", JSON.stringify(this.rows));

                $("#antec_modal").modal("hide");
                this.actualRow = localStorage.getItem("permisos_recep");
                this.rows = JSON.parse(this.actualRow);
                this.rows = this.rows.concat({
                    tipo_permiso: this.temp_perm.tipo_permiso,
                    permiso: this.temp_perm.permiso,
                    numero: this.temp_perm.numero,
                    fecha: this.temp_perm.fecha,
                    superficie: this.temp_perm.superficie,
                    recepcion: this.temp_perm.recepcion,
                    fecha_recep: this.temp_perm.fecha_recep,

                })
                localStorage.setItem("permisos_recep", JSON.stringify(this.rows));
                //this.temp_perm.reset();
                this.dialog.closeAll();
            }
        }
    }

}